export const signInFormDefaults = {
  email: '',
  password: '',
  error: null
}



// WEBPACK FOOTER //
// ./src/constants/signInFormDefaults.js